// extracted by mini-css-extract-plugin
export default {"container":"container__qeUZ0bti","label":"label__CRfrKKpD","checkbox":"checkbox__uqPJc1aN","checkIcon":"checkIcon__rkrrwaeq"};